import { extend, setInteractionMode, localize } from "vee-validate";
import * as rules from "vee-validate/dist/rules";
import messages from "vee-validate/dist/locale/en.json";
import frMessages from "vee-validate/dist/locale/fr.json";

// Determine locale and messages to use
const isFrench = window.Shopify?.locale === "fr";
const activeMessages = isFrench ? frMessages : messages;

// Configure locale
localize(isFrench ? "fr" : "en", activeMessages);

Object.keys(rules).forEach((rule) => {
  extend(rule, {
    ...rules[rule], // copies rule configuration
    message: activeMessages.messages[rule], // assign message from active locale messages
  });
});

extend("confirm-nocase", {
  params: ["target"],
  validate: (value, { target }) => {
    return value.toLowerCase() === target.toLowerCase();
  },
  message: activeMessages.messages.confirmed,
});

setInteractionMode("eager");
